const branding = { key: 'phishing' }

export { branding }
